import http from '@/assets/common/http';
// ------------------------------------------查询库存功能
export function queryWarehouseFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询库存流水功能
export function querystockFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 27,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------导出库存功能
export function exportWarehouseFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------仓库退库
export function returnFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 28,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function returnXMDFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询仓库中商品一级大类
export function queryFirstFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 13,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function querySecondFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 49,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询入库数据
export function queryInStorageFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 14,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------查询入库详情数据
export function queryInStorageDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 15,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------入库确认接口
export function inStorageCofirmFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -----------------------------------------------------------入库拆箱
export function unpackingFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库接口
export function stockOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库详情接口
export function stockOutDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库修改拉取数据接口
export function updatestockDataFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 21,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库修改确认接口
export function updatestockOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 19,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库确认接口
export function stockOutAllFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------历史入库单
export function historyInFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 43,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------历史出库单打印次数
export function historyPrintTime(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 28,
    ...data,
  };
  return http.post(params);
}
// -------------------------导出历史入库单
export function exportInStockData(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 48,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function historyInDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 44,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function historyReturnFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 45,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params, { skipParamsCheck: true, showLoading: false });
}
// ------------------------------------------盈亏表接口
export function profitFun(data) {
  const params = {
    SERVICE_ID: '10030',
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------创建盘库单功能
export function creatStokFun(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------查询盘库详情功能
export function queryStokDetailFun(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------新增盘库单功能
export function addStokFun(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------删除盘库单功能
export function delEntry(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------导出盘库单功能
export function exportPKFun(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 7,
    ...data,
  };
  return http.post(params);
}
// ---------------------------------------------出库单
export function historyOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 22,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库单详情接口
export function historyOutDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 23,
    ...data,
  };
  return http.post(params);
}
export function addNewProduct(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 42,
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------出库单详情接口
export function closeNewProduct(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 37,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------到出历史出库单
export function exportHisOutData(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 41,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出旧版
export function exportHisOutOldData(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 71,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 库存报损
export function lossFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 53,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ===========================================出库修改后的接口
// ---------------------------------------------出库汇总单
export function getMTOKindFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function queryMTOtable(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function queryMTStable(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 确认出库
export function submitOutFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 出库汇总单
export function totalOutFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取出库汇总单详情
export function totalOutDetailFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 预处理
export function dealFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 11,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 报损
export function reportLossFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 12,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 提交报损
export function submitReportFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 10,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 完成报损
export function overReportFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 9,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改某商品剩余库存数量
export function findWareFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 13,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 确认提交
export function editOutFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 14,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 合箱
export function addBoxFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 54,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取匹配产品
export function queryMatchFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取合箱目标产品
export function addBoxListFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 55,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取MTS、MTO出库界面可合箱产品
export function wareBoxListFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 56,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取MTS、MTO出库界面可拆箱产品
export function wareSperateListFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 57,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 总出库单退货
export function totalReturnFun(data) {
  const params = {
    SERVICE_ID: '10058',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取可出库产品
export function queryWareProductFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 66,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 单个出库
export function singleOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 67,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 按0出库
export function noOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 68,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 订单完成出库
export function overOutFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 69,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询出库详情
export function queryOutDetailFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 70,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 盘库下载导入盘库表
export function downLoadStock(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 确定提交导入盘库表
export function leadingInSuccess(data) {
  const params = {
    SERVICE_ID: '10030',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除缺货记录
export function delData(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 33,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------------------设置盘盈盘亏颜色显示
export function setFontColor(number) {
  if (number > 0) {
    return {
      color: '#67C23A',
    }; // green
  } if (number === 0) {
    return {
      color: '#606266',
    }; // normal
  }
  return {
    color: '#F56C6C',
  }; // red
}
// 设置出库颜色
export function setOutFontColor(number) {
  if (number !== 1) {
    return {
      // backgroundColor: '#F56C6C'
      color: '#F56C6C',
    };
  }
}
// -------------------------------------------打印
/**
 * 打印页面数据
 * @param {String} content html流
 * @param {*} w 长度
 * @param {*} h 高度
 */
export function print(content, footer = '', isRow = true, w = null, h = null) {
  content += footer;
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  w = +w === 0 ? width : w;
  h = +h === 0 ? height : h;
  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;
  const myWindow = window.open('', '打印', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
  // 打印表格样式
  const style = "<style type='text/css'>.title {font-size: 30px;text-align: center; margin-bottom: 15px} .head{width: 100%; display: flex; justify-content: space-between;margin-bottom: 15px} .divFooter{position: fixed; display: flex; justify-content: space-between;bottom: 0;}.divFooter>div{margin-right: 100px} table{width: 100%} table.el-table__body {width: 600px;font-family: verdana,arial,sans-serif;font-size:11px;color:#333333;border-width: 1px;border-color: #666666;border-collapse: collapse}table.el-table__body, table.el-table__header th {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #dedede}table.el-table__body td {border-width: 1px;padding: 5px;border-style: solid;border-color: #666666;background-color: #ffffff}}</style>";
  myWindow.document.write(content + style);
  myWindow.focus();
  myWindow.document.close(); // 关闭document的输出流, 显示选定的数据
  myWindow.print.portrait = isRow;
  myWindow.print(); // 打印当前窗口
  return myWindow;
}
// --------------------------------------------开始日期显示范围
export const pickerOptionStart = {
  // 日期范围控制在今天之前三个月之内
  disabledDate(time) {
    const curDate = (new Date()).getTime();
    const three = 90 * 24 * 3600 * 1000;
    const threeMonths = curDate - three;
    return time.getTime() > Date.now() || time.getTime() < threeMonths;
  },
  shortcuts: [{
    text: '今天',
    onClick(picker) {
      picker.$emit('pick', new Date());
    },
  }, {
    text: '昨天',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', date);
    },
  }, {
    text: '一周前',
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', date);
    },
  }],
};
// 入库详情搜索接口
export function chooseEntryFun(data) {
  const params = {
    // SERVICE_ID: '10035',
    SERVICE_ID: '20002',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ---------------------------------报溢
export function addCountFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 73,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出库存流水
export function exportRecordFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 74,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 仓库区域
// 拉取区域
export function queryWarehouseType(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 4,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增仓库区域类型
export function addWarehouseType(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增库位
export function addWarehousePosition(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 5,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 查询所有库位
export function queryPosition(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 6,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改库位状态
export function updatePositionStatus(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导入库位数据
export function importPosition(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改库位状态
export function updatePosition(data) {
  const params = {
    SERVICE_ID: '10051',
    OTYPE: 12,
    ...data,
  };
  return http.post(params);
}
// 导出当天供应商和订单
export function exportCurrent() {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 1,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// ------------------------------入库-手动录入-新增商品
export function addInstockConfirm(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ------------------------------入库-赠品入库-新增商品
export function addGiftsInstockConfirm(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 34,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS入库-手动入库-导入
export function manualImport(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 5,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS临时仓-导入
export function temporaryImport(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 8,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------获取临时仓库存
export function queryTemporary(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------临时仓上架
export function putOnStock(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 4,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------临时仓批量上架
export function putOnStock_multy(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS临时仓-导出
export function temporaryExport(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 7,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS库存-锁定商品
/**
 * 锁定库存商品（支持单条或批量）
 * @param {Object} data 请求数据
 * @param {Array<number>} data.DETAIL_ID 库存明细ID数组（GYS_Warehouse_Detail 主键）
 * @param {string} [data.LOCK_REASON] 锁库原因（选填，最长200字符）
 * @returns {Promise}
 */
export function sotckLock(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 9,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS库存-解锁商品
export function sotckUnLock(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function exportExclStock() {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 筛选临保单品
export function sotckNearExpire(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出临保产品
export function exportWhouseMsg() {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 13,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
  };
  return http.post(params);
}
// 移库
export function movingStockPosition(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 14,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------库存预警
export function queryStockWarning(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 15,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS拣货单-总拣单
export function WMSpickListAll(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 24,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS拣货单-历史拣货单
export function WMShistoryPickList(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 23,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------手动入库查询-详情
export function manualInstockDetail(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 16,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 导出手动入库详情
export function exportManualInstockFun(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS出库-二次出库-查询
export function secondOutQuery(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 18,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS出库-二次出库-批量出库
export function secondOutMulty(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 19,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量出库
export function WMSmultyOut(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 20,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------历史入库单每行数据导出
export function exportRowDetail(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 21,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 历史出库单每行数据
export function exportStockRowDetail(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 22,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS拣货单-历史拣货单-详情
export function WMShistoryPickListDetail(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 25,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// -------------------------------------------WMS拣货单-历史拣货单-导出
export function WMShistoryExportPickListDetail(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 30,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取库位
export function getShopReturnLocationFun(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 26,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------获取退货仓
export function queryReturnStock(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 27,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------退货仓-重新上架
export function putBackOnStock(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 28,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// --------------------------------退货仓-退货
export function stockReturn(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 29,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取一级、二级、三级大类
export function getClassFun(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 一键入库
export function shortcutStorage(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 81,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 获取一级、二级、三级大类
export function searchProduct(data) {
  const params = {
    SERVICE_ID: '10074',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 添加完成
export function manualOutStockFun(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 99,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 二次出库导出
export function secondOutExportFun(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 32,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改生产日期
export function submitUpdate(data) {
  const params = {
    SERVICE_ID: '10177',
    OTYPE: 101,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 库存上传批次报告
export function stockUploadBatchReport(data) {
  const params = {
    SERVICE_ID: '10176',
    OTYPE: 17,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}

export function 获取出库验收差异数据(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 108,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}

export function 产品列表退库且报损(data) {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 109,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}

// ------------------------------------------SCM 库存操作类型字典
/**
 * 获取 SCM 库存操作类型字典（SCM_STOCK_OPERATION_TYPE）
 * @returns {Promise<Array<{NAME: string, VALUE: number}>>} 字典参数列表，按 SORT_NO 升序
 */
export function getStockOperationTypeList() {
  const params = {
    SERVICE_ID: '10031',
    OTYPE: 106,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/warehouseManager.js